import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { QueryOptions, queryOptions, useQuery } from "@tanstack/react-query";
import { CoursesSearchParams } from "@vixi/router";
import { Paginated, ShallowCourse } from "@vixi/types";

export interface AllCoursesQueryParams extends CoursesSearchParams {}

export const allCoursesQueryFn = ({
  pageNumber = 1,
  ...params
}: AllCoursesQueryParams = {}): QueryOptions<Paginated<ShallowCourse>>["queryFn"] => {
  return async ({ signal }) => {
    const response = await api.get<Paginated<ShallowCourse>>(endpoints.getAllCourses, {
      params: { pageNumber, ...params },
      signal,
    });

    return response.data;
  };
};

export const allCoursesQueryOptions = (options: AllCoursesQueryParams = {}) => {
  return queryOptions({
    queryKey: ["courses", options],
    queryFn: allCoursesQueryFn(options),
    placeholderData: (prev) => {
      if (prev) {
        const { items, ...paginationInfo } = prev;
        return {
          ...paginationInfo,
          pageNumber: options.pageNumber ?? 1,
          pageSize: options.pageSize ?? prev.items?.length,
        };
      }

      return undefined;
    },
  });
};

export const useAllCourses = (options: AllCoursesQueryParams = {}) => {
  return useQuery(allCoursesQueryOptions(options));
};
